export default {
	login: {
		loginTitle: 'Welcome to',
		loginTitlefont: 'Please sign in to begin your journey.',
		inputNameFonts: 'Email Address',
		inputName: 'Enter Your Email',
		inputPasswordFonts: 'Password',
		inputPassword: 'Enter Your Password',
		ForgotPassword: 'Forgot Password ?',
		loginButton: 'Continue',
		SignUp: "Don't have an account?",
		SignUpA: 'Sign up',
		googleButton: 'Continue with google',
		errorFonts: '您输入的账号或者密码不正确！',
		outLogin: 'log out',
	},
	pricing: {
		pricingTitle: 'Subscription Plan',
	},
	home: {
		headerLanguage: '中文',
		headerLogin: '登录'
	},
	content: {
		typeface1: "Leading Generative Al For",
		typeface2: "3D Creativity",
		fontsname: 'the new approach to 3D objects and 3D scenes in gaming,metaverse,robotics',
		buttonLeft: 'Try Now-it`s free',
		buttonRight: 'View price&APi',
		buttonButtom: 'Download App',
		technologyFont: 'See Our Technology in Action',
		littleFont: 'Our early adopters have shared enthusiastic and positive feedback.',
		swiperFont: 'Community Showcase',
		swiperFontmin1: 'Get inspired by how our community members are leveragin the power of sudoAl to',
		swiperFontmin2: 'create 3D content from text or image.'
	},
	footerTitle: {
		titlename: 'Stay Turned By Joining Our E-Mail List',
		footerBottomName: 'Copyright © SUDOAI | All Rights Reserved'
	},
	accountRecord: {
		apiKeys: 'API keys',
		Usage: 'Usage',
		RencentModels: 'Rencent Models',
		CurrentPlan: 'Current Plan',
		free: 'Free',
		PerMonth: 'Per month',
		MonthlyCredit: 'Monthly Credit',
		ApiAccess: 'API access',
		UpgradeNow: 'Upgrade Now',
		credits: 'Credits',
		Left: 'Left',
		MonthlyCredit40: 'Monthly Credit',
		PermanentCredits: 'Permanent credits',
		addCredits: 'Add Credits',
		GetFreeCredis: 'Get Free Credis?',
		GetFreeCredits: 'Get Free Credits',
		GetFreeCreditsFontsTop: 'Free Users Receive',
		GetFreeCreditsFontsTop2: '40 Monthly',
		GetFreeCreditsFontsTop3: 'Credits That Reset At 00:00 (UTC) On The 1st Of Every Month.',
		GetFreeCreditsFontsBottom: 'Sharing Your 3D Generation Results On Twitter Will Allow You To Earn ',
		GetFreeCreditsFontsBottom2: 'Anadditional 10 Credits ',
		GetFreeCreditsFontsBottom3: ', With A Maximum Of 100 Credits Per Month.',
		PurchaseExtraCredit: 'Purchase extra credit',
		PurchaseExtraCreditMoneyLeft: '$0',
		PurchaseExtraCreditExplainLeft: '40 credits',
		PurchaseExtraCreditMoneyRight: '$16',
		PurchaseExtraCreditExplainRight: '160 credits',
	},
	APIKeys: {
		APIKeys: 'API Keys',
		UpgradeAPIKeys: 'Upgrade your subscription plan to enable API access.',
		APIReference: 'API Reference',

	},
	Usage: {
		Usage: 'Usage',
		UsageCredits: 'Your credits usage list including app and api.',
	},
	rencentModels: {
		rencentModels: 'My Models',
		rencentModelsModeled: 'Here is the model you have already modeleds',
	},
	Generate3D: {
		Generate3D: 'Generate 3D',
		ImageTo3D: 'Image to 3D',
		TextTo3D: 'Text to 3D',
		explain: 'Please upload an image featuring a single complete object in a front view against a clear background. Tutorial',
		SelectFromExamples:'Select from examples',
		AccountSettings:'Account Settings',
		outLogin: 'Logout',
		AssistantPanel:'Assistant Panel',
		SimilarExistingModels: 'Similar Existing Models',
		History: 'History',
	},
	cashierdeskMain:{
		cashierdeskTitle:'向sudoAI .inc.支付',
		
	}
};
